import { Heading } from 'blaze-ui/Heading/Heading'
import { FormikDaysBeforeReviewRadioGroup } from 'screens/VirtualMarketerOnboarding/CustomizeSchedule/DaysBeforeReviewRadioGroup'
import { useId } from '@react-aria/utils'
import Styles from './EditScheduleModal.module.scss'
import { useField } from 'formik'
import { Text } from 'blaze-ui/Text/Text'
import { WrapperCard } from 'components/AddCampaignModal/WrapperCard'

export const ReviewTime = () => {
  const id = useId()
  const [, meta] = useField<number>('days_before_review')
  return (
    <WrapperCard>
      <Heading level={4} id={id}>
        Review time before posting
      </Heading>
      <FormikDaysBeforeReviewRadioGroup name="days_before_review" aria-labelledby={id} className={Styles.radioGroup} />
      {meta.touched && meta.error && (
        <Text variant="secondary" color="var(--negative-50)">
          {meta.error}
        </Text>
      )}
    </WrapperCard>
  )
}
